namespace appn.views.dataSources.createOrEdit {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        // Toggle show/hide of interaction target
        $('.interaction').change(function() {
            const val = $(this).find('option:selected').val();
            const dataSourceInteractTarget = $('#DataSource_AppConfig_InteractTarget');
            if (val === 'OpenScreen') 
                $(dataSourceInteractTarget).closest('.group-interact-target').removeClass('d-none');
             else 
                $(dataSourceInteractTarget).closest('.group-interact-target').removeClass('d-none').addClass('d-none');

            if (val === 'None' || val === 'ForceSync' || val === 'RefreshScreen') 
                $('.group-interact-column').removeClass('d-none').addClass('d-none');
            else
                $('.group-interact-column').removeClass('d-none');
        });

        // Toggle show/hide of sort order desc target
        $('.sorttype').change(function() {
            const val = $(this).find('option:selected').val();
            const target = $('.group-sortby-column');
            if (val !== 'None')
                $(target).removeClass('d-none');
            else
                $(target).removeClass('d-none').addClass('d-none');
        });

        $('.sorttype').trigger('change');
    }
}
